import Button from "@/shared/form/button";
import { UploadOutlined } from "@ant-design/icons";
import Text from "@/shared/typography/text";
import { Attachments } from "@/shared/form/upload";
import { useTranslations } from "use-intl";
import ImgCrop from "antd-img-crop";
import { AttachmentsProps } from "@/shared/form/upload/ui/attachment/attachment";

export function PostImage(attachmentsProps: AttachmentsProps) {
  const t = useTranslations("PostForm");
  const tc = useTranslations("Common");

  return (
    <ImgCrop
      cropShape={"rect"}
      aspect={16 / 9}
      modalTitle={tc("Crop image")}
      modalOk={tc("Save")}
      modalCancel={tc("Cancel")}
      modalClassName="[&.img-crop-modal]:z-[2000]"
    >
      <Attachments {...attachmentsProps}>
        <Button
          data-testid="create-post-media-button"
          icon={<UploadOutlined />}
          iconPosition="end"
        >
          <Text as="span" type="inherit" color="inherit">
            {t("Click to upload")}
          </Text>
        </Button>
      </Attachments>
    </ImgCrop>
  );
}
